import _filter from 'lodash/filter'
import _orderBy from 'lodash/orderBy'
import _result from 'lodash/result'
import _get from 'lodash/get'
import { connect } from 'react-redux'
import React from 'react'
import Modal from 'react-modal'
import modalStyle from '../../../_common/core/modalStyle'
import LoadingBar from '../../_library/LoadingBar'
import Button from '../../_library/Button'
import {
  FETCH_BRAND_TEAM_INVITATIONS,
  FETCH_BRAND_TEAM_MEMBERS,
  ADD_BRAND_TEAM_INVITATION,
  RESEND_BRAND_TEAM_INVITATION,
  UPDATE_BRAND_PROMOTER_GENERIC_INVITATION,
  ADD_BRAND_TEAM_INVITATION_LOCAL,
} from '../../../_common/redux/brandteam/actions'
import {
  DELETE_PERMISSION,
  CANCEL_INVITATION,
  EDIT_PERMISSION,
} from '../../../_common/redux/eventteam/actions'
import {
  FETCH_BRAND_PROMOTER_GENERIC_INVITATION,
  REGENERATE_PROMOTER_GENERIC_INVITATION_BRAND,
} from '../../../_common/redux/brandteam/actions'
import { JSONDatatable, TYPE_FROM_ARRAY, SEARCHBAR, DATATABLE } from '../../_library/JSONDatatable'

import BrandTeamInvitationForm from './BrandTeamInvitationForm'
import BrandEditTeamInvitationForm from './BrandEditTeamInvitationForm'
import Clipboard from '../../_library/Clipboard'
import { getTitle } from '../../utils/getTitle'
import { IS_TF_MEMBER } from '../../events/EventTeam'
import { ROLES } from '../../constants/roles'

const INVITATION_INITIAL_VALUES = {
  attributes: {
    role: 'promoter',
  },
}

const ROLES_MAP = {
  owner: 'Owner',
  admin: 'Administrator',
  stats: 'Stats',
  limited_stats: 'Limited Stats',
  promoter: 'Promoter',
  staff: 'Door Staff',
  curator: 'Curator',
  support: 'Customer Support',
  limited_support: 'Limited Support',
}

@connect(
  state => {
    const invitations = state.brandteam.invitations.attributes
    const { members } = state.brandteam
    const brand = state.brands.selected
    const { user } = state.auth
    return {
      user,
      brand,
      invitations,
      members,
      promoterGenericInvitation: state.brandteam.promoterGenericInvitation,
    }
  },
  {
    UPDATE_BRAND_PROMOTER_GENERIC_INVITATION,
    REGENERATE_PROMOTER_GENERIC_INVITATION_BRAND,
    FETCH_BRAND_PROMOTER_GENERIC_INVITATION,
    FETCH_BRAND_TEAM_INVITATIONS,
    FETCH_BRAND_TEAM_MEMBERS,
    ADD_BRAND_TEAM_INVITATION,
    CANCEL_INVITATION,
    DELETE_PERMISSION,
    RESEND_BRAND_TEAM_INVITATION,
    EDIT_PERMISSION,
    ADD_BRAND_TEAM_INVITATION_LOCAL,
  },
)
export default class BrandTeam extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loadingInvitations: false,
      loadingGenericPromoterInvitation: false,
      loadingMembers: false,
      showNewInvitationModal: false,
      showCancelInvitationModal: false,
      invitationToCancel: null,
      cancelingInvitation: false,
      showDeleteConfirmModal: false,
      permissionToDelete: null,
      deleting: false,
      showEditConfirmModal: false,
      permissionToEdit: null,
      showInvitationLinkChangeModal: false,
      selectedRoleFilter: 'all',
    }
    this.getMembersFilteredRows = this.getMembersFilteredRows.bind(this)
    this.getMembersSortedRows = this.getMembersSortedRows.bind(this)
    this.getMembersTableData = this.getMembersTableData.bind(this)
    this.onClickNewInvitation = this.onClickNewInvitation.bind(this)
    this.getInvitationsFilteredRows = this.getInvitationsFilteredRows.bind(this)
    this.getInvitationsSortedRows = this.getInvitationsSortedRows.bind(this)
    this.getInvitationsTableData = this.getInvitationsTableData.bind(this)
    this.onCancelNewInvitation = this.onCancelNewInvitation.bind(this)
    this.handleNewInvitationSubmit = this.handleNewInvitationSubmit.bind(this)
    this.onCancelDelete = this.onCancelDelete.bind(this)
    this.deletePermission = this.deletePermission.bind(this)
    this.onCancelInvitationCancel = this.onCancelInvitationCancel.bind(this)
    this.cancelInvitation = this.cancelInvitation.bind(this)
  }

  regenerateGenericPromoterInvitation = async () => {
    try {
      const {
        REGENERATE_PROMOTER_GENERIC_INVITATION_BRAND,
        promoterGenericInvitation: { token },
      } = this.props
      !this.isUnmounted && this.setState({ loadingGenericPromoterInvitation: true })
      await REGENERATE_PROMOTER_GENERIC_INVITATION_BRAND(token)
      !this.isUnmounted && this.setState({ loadingGenericPromoterInvitation: false })
    } catch (e) {
      !this.isUnmounted && this.setState({ loadingGenericPromoterInvitation: false })
    }
  }

  fetchGenericPromoterInvitation = async () => {
    try {
      const { brand, FETCH_BRAND_PROMOTER_GENERIC_INVITATION } = this.props
      !this.isUnmounted && this.setState({ loadingGenericPromoterInvitation: true })
      await FETCH_BRAND_PROMOTER_GENERIC_INVITATION(brand.id)
      !this.isUnmounted && this.setState({ loadingGenericPromoterInvitation: false })
    } catch (e) {
      !this.isUnmounted && this.setState({ loadingGenericPromoterInvitation: false })
    }
  }

  disableOrEnableGenericPromoterInvitation = async () => {
    try {
      const { UPDATE_BRAND_PROMOTER_GENERIC_INVITATION, promoterGenericInvitation } = this.props
      !this.isUnmounted && this.setState({ loadingGenericPromoterInvitation: true })
      await UPDATE_BRAND_PROMOTER_GENERIC_INVITATION(promoterGenericInvitation.id, {
        id: promoterGenericInvitation.id,
        status: promoterGenericInvitation.status === 'disabled' ? 'pending' : 'disabled',
      })
      !this.isUnmounted && this.setState({ loadingGenericPromoterInvitation: false })
    } catch (e) {
      !this.isUnmounted && this.setState({ loadingGenericPromoterInvitation: false })
    }
  }

  componentDidMount() {
    const {
      brand: { displayName },
      configs,
    } = this.props
    const configDocTitle = _get(configs, 'messages.documentTitle', '')
    document.title = getTitle(configDocTitle, [displayName])
    this.fetchInvitations()
    this.fetchMembers()
    this.fetchGenericPromoterInvitation()
    
    // Add scroll listener for sticky button
    this.handleScroll = this.handleScroll.bind(this)
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    this.isUnmounted = true
    // Remove scroll listener
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll = () => {
    const stickyButton = document.querySelector('.sticky-invite-button-container')
    if (stickyButton) {
      const scrollPosition = window.scrollY
      const threshold = 100 // Adjust this value as needed
      
      if (scrollPosition > threshold) {
        stickyButton.classList.add('scrolled')
      } else {
        stickyButton.classList.remove('scrolled')
      }
    }
  }

  fetchInvitations = async (indicator = true) => {
    try {
      const { brand, FETCH_BRAND_TEAM_INVITATIONS } = this.props
      indicator && this.setState({ loadingInvitations: true })
      const res = await FETCH_BRAND_TEAM_INVITATIONS(brand.id)
      indicator && this.setState({ loadingInvitations: false })
      return res
    } catch (err) {
      indicator && this.setState({ loadingInvitations: false })
    }
  }

  fetchMembers = async (indicator = true) => {
    try {
      const { brand, FETCH_BRAND_TEAM_MEMBERS } = this.props
      indicator && this.setState({ loadingMembers: true })
      const res = await FETCH_BRAND_TEAM_MEMBERS(brand.id)
      indicator && this.setState({ loadingMembers: false })
      return res
    } catch (err) {
      indicator && this.setState({ loadingMembers: false })
    }
  }

  getInvitationsFilteredRows(rows, search) {
    const isFound = (value, keyword) => {
      if (!value) return 0
      return value.toLowerCase().indexOf(keyword) !== -1 ? 1 : 0
    }
    let rows_filtered = rows
    const keyword = search.join('').trim().toLowerCase()
    if (keyword !== '') {
      rows_filtered = _filter(rows_filtered, item => {
        let found = 0
        found += isFound(item.firstName, keyword)
        found += isFound(item.lastName, keyword)
        found += isFound(item.email, keyword)
        found += isFound(item.role, keyword)
        return found > 0
      })
    }
    return rows_filtered
  }

  getInvitationsSortedRows(rows_filtered, sort) {
    // Define role hierarchy (highest to lowest)
    const roleHierarchy = ['owner', 'admin', 'stats', 'limited_stats', 'curator', 'staff', 'promoter', 'support', 'limited_support'];
    
    // Sort by role hierarchy first, then by name
    rows_filtered = _orderBy(
      rows_filtered, 
      [
        // First sort by role hierarchy
        (invitation) => {
          const role = invitation.role;
          const index = roleHierarchy.indexOf(role);
          return index === -1 ? roleHierarchy.length : index;
        },
        // Then sort by full name
        (invitation) => `${invitation.firstName} ${invitation.lastName}`.toLowerCase()
      ],
      ['asc', 'asc'] // Ascending for both (lower index = higher priority for roles)
    );
    
    return rows_filtered
  }

  getInvitationsTableData(datatable, rows_filtered, sort) {
    const { user } = this.props

    const content_header = datatable.getHeaderRow(
      datatable,
      [
        { title: 'Name', sort: false },
        { title: 'Email', sort: false },
        { title: 'Role', sort: false },
        { title: 'Status', sort: false },
        { title: 'Actions', sort: false },
      ],
      sort,
    )

    return (
      <table className="table brand-team-invitations-table">
        <thead>{content_header}</thead>
        <tbody>
          {rows_filtered.map((row, index) => (
            <tr key={index} className={index % 2 === 0 ? 'row-stale' : ''}>
              <td>
                {row.firstName} {row.lastName}
              </td>
              <td>{row.email}</td>
              <td>
                <div className="role">
                  <span className={`circle ${row.role}`} />
                  <span>{ROLES_MAP[row.role]}</span>
                </div>
              </td>
              <td>{row.status}</td>
              <td>
                {!ROLES.is_tf_support_or_client_support(user?.tfRole) && (
                  <>
                    <Button
                      type="button"
                      disabled={row.status === 'accepted' || !row.id}
                      className="btn btn-primary"
                      onClick={this.resendInvitation.bind(this, row)}
                    >
                      <i className="fa fa-undo" />
                      Resend
                    </Button>
                    <Button
                      type="button"
                      disabled={row.status === 'accepted' || !row.id}
                      className="btn btn-danger"
                      onClick={this.onClickCancelInvitation.bind(this, row)}
                    >
                      <i className="fa fa-times" />
                      Cancel
                    </Button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }

  getMembersFilteredRows(rows, search) {
    const isFound = (value, keyword) => {
      if (!value) return 0
      return value.toLowerCase().indexOf(keyword) !== -1 ? 1 : 0
    }
    let rows_filtered = rows
    const keyword = search.join('').trim().toLowerCase()
    if (keyword !== '') {
      rows_filtered = _filter(rows_filtered, item => {
        let found = 0
        found += isFound(item.attributes.firstName, keyword)
        found += isFound(item.attributes.lastName, keyword)
        found += isFound(item.attributes.firstName + ' ' + item.attributes.lastName, keyword)
        found += isFound(item.attributes.lastName + ' ' + item.attributes.firstName, keyword)
        found += isFound(item.attributes.email, keyword)
        return found > 0
      })
    }
    return rows_filtered
  }

  handleEditInvitationSubmit = async form => {
    try {
      const { permissionToEdit } = this.state
      const { EDIT_PERMISSION } = this.props
      await EDIT_PERMISSION(permissionToEdit.roleBrand.id, form)
      this.fetchMembers(false)
      this.setState({
        showEditConfirmModal: false,
        permissionToEdit: null,
      })
      return
    } catch (err) {
      this.setState({
        showEditConfirmModal: false,
        permissionToEdit: null,
      })
    }
  }

  cancelInvitation = async () => {
    try {
      const { CANCEL_INVITATION } = this.props
      const { invitationToCancel } = this.state
      this.setState({ cancelingInvitation: true })
      const res = await CANCEL_INVITATION(invitationToCancel.token)
      this.fetchInvitations(false)
      this.setState({
        cancelingInvitation: false,
        invitationToCancel: null,
        showCancelInvitationModal: false,
      })
      return res
    } catch (err) {
      this.setState({
        invitationToCancel: null,
        showCancelInvitationModal: false,
      })
      Promise.reject(_result(err, 'toFieldErrors', err))
    }
  }

  deletePermission = async () => {
    try {
      const { DELETE_PERMISSION } = this.props
      const { permissionToDelete } = this.state
      this.setState({ deleting: true })
      const res = await DELETE_PERMISSION(permissionToDelete.roleBrand.id)
      this.fetchMembers(false)
      this.setState({
        deleting: false,
        permissionToDelete: null,
        showDeleteConfirmModal: false,
      })
      return res
    } catch (err) {
      this.setState({
        deleting: false,
        permissionToDelete: null,
        showDeleteConfirmModal: false,
      })
      Promise.reject(_result(err, 'toFieldErrors', err))
    }
  }

  resendInvitation = async invitation => {
    try {
      const {
        match: {
          params: { id },
        },
        RESEND_BRAND_TEAM_INVITATION,
      } = this.props
      const res = await RESEND_BRAND_TEAM_INVITATION(id, invitation.email)
      Messenger().post({
        type: 'success',
        message: 'The invitation is successfully resent',
        hideAfter: 3,
        showCloseButton: true,
      })
      return res
    } catch (err) {
      Promise.reject(_result(err, 'toFieldErrors', err))
    }
  }

  getMembersSortedRows = (rows_filtered, sort) => {
    // This method needs to be called from render context to access roleCounts
    // Will be bound with proper context in render method
    
    // First check if we have access to the dynamic role order
    if (this.dynamicRoleOrder && this.dynamicRoleOrder.length > 0) {
      const roleOrder = this.dynamicRoleOrder;
      
      // Sort by the dynamic role order
      rows_filtered = _orderBy(
        rows_filtered, 
        [
          // First sort by role position in the dynamic order
          (member) => {
            const role = member.roleBrand?.role;
            const index = roleOrder.indexOf(role);
            return index === -1 ? roleOrder.length : index;
          },
          // Then sort by full name
          (member) => `${member.attributes.firstName} ${member.attributes.lastName}`.toLowerCase()
        ],
        ['asc', 'asc']
      );
    } else {
      // Fallback to static hierarchy if dynamic order not available
      const roleHierarchy = ['owner', 'admin', 'stats', 'limited_stats', 'curator', 'staff', 'promoter', 'support', 'limited_support'];
      
      rows_filtered = _orderBy(
        rows_filtered, 
        [
          (member) => {
            const role = member.roleBrand?.role;
            const index = roleHierarchy.indexOf(role);
            return index === -1 ? roleHierarchy.length : index;
          },
          (member) => `${member.attributes.firstName} ${member.attributes.lastName}`.toLowerCase()
        ],
        ['asc', 'asc']
      );
    }
    
    return rows_filtered
  }

  getMembersTableData(datatable, rows_filtered, sort) {
    const { user } = this.props
    
    // Get myRole from the complete member list (this.allMembers), not the filtered rows
    // This ensures we can always determine the current user's role regardless of filters
    const myRole = this.allMembers?.find(member => member.id == user.id)?.roleBrand?.role

    const content_header = datatable.getHeaderRow(
      datatable,
      [
        { title: 'Name', sort: false },
        { title: 'Email', sort: false },
        { title: 'Role at Tour Level', sort: false },
        { title: 'Role at Brand Level', sort: false },
        { title: 'Actions', sort: false },
      ],
      sort,
    )

    const isOwner = myRole === 'owner'
    const isAdmin = myRole === 'admin'

    return (
      <table className="table brand-team-members-table">
        <thead>{content_header}</thead>
        <tbody>
          {rows_filtered.length === 0 && (
            <tr>
              <td colSpan="5" className="text-center">
                No Members Found
              </td>
            </tr>
          )}
          {rows_filtered.length > 0 &&
            rows_filtered.map((row, index) => {
              const canModifyAsOwner = row.attributes.email !== user.email
              const canModifyAsAdmin = !(row.roleBrand.role === 'owner' || row.roleBrand.role === 'admin')
              return (
                <tr key={index} className={index % 2 === 0 ? 'row-stale' : ''}>
                  <td>
                    {row.attributes.firstName} {row.attributes.lastName}
                  </td>
                  <td>{row.attributes.email}</td>
                  <td>
                    {row.roleTour && (
                      <div className="role">
                        <span className={`circle ${row.roleTour.role}`} />
                        <span>{ROLES_MAP[row.roleTour.role]}</span>
                      </div>
                    )}
                  </td>
                  <td>
                    {row.roleBrand && (
                      <div className="role">
                        <span className={`circle ${row.roleBrand.role}`} />
                        <span>{ROLES_MAP[row.roleBrand.role]}</span>
                      </div>
                    )}
                  </td>
                  {(user && ROLES.is_tf_support_admin_or_client_admin(user?.tfRole)) ||
                  user?.isSuperAdmin ||
                  (myRole && ((isOwner && canModifyAsOwner) || (isAdmin && canModifyAsAdmin))) ? (
                    <td>
                      <Button
                        disabled={!row.currentManufacturer}
                        title={
                          !row.currentManufacturer ? 'Team member has access from parent brand' : undefined
                        }
                        className="btn btn-primary"
                        onClick={this.onClickEdit.bind(this, row)}
                      >
                        <i className="fa fa-pencil" />
                        Edit
                      </Button>
                      <Button
                        disabled={!row.currentManufacturer}
                        title={
                          !row.currentManufacturer ? 'Team member has access from parent brand' : undefined
                        }
                        className="btn btn-danger"
                        onClick={this.onClickDelete.bind(this, row)}
                      >
                        <i className="fa fa-trash" />
                        Delete
                      </Button>
                    </td>
                  ) : (
                    <td />
                  )}
                </tr>
              )
            })}
        </tbody>
      </table>
    )
  }

  onClickNewInvitation() {
    this.setState({
      showNewInvitationModal: true,
    })
  }

  onCancelNewInvitation() {
    this.setState({
      showNewInvitationModal: false,
    })
  }

  handleNewInvitationSubmit = async form => {
    try {
      const { brand, ADD_BRAND_TEAM_INVITATION, ADD_BRAND_TEAM_INVITATION_LOCAL } = this.props
      const res = await ADD_BRAND_TEAM_INVITATION(brand.id, form)
      ADD_BRAND_TEAM_INVITATION_LOCAL(form)

      Messenger().post({
        type: 'success',
        message: res.message,
        hideAfter: 3,
        showCloseButton: true,
      })

      this.setState({
        showNewInvitationModal: false,
      })
      setTimeout(() => {
        this.fetchInvitations(false)
      }, 10000)
      return res
    } catch (err) {
      this.setState({
        showNewInvitationModal: false,
      })
      Promise.reject(_result(err, 'toFieldErrors', err))
    }
  }

  onClickCancelInvitation(invitation) {
    this.setState({
      invitationToCancel: invitation,
      showCancelInvitationModal: true,
    })
  }

  onCancelInvitationCancel() {
    this.setState({
      invitationToCancel: null,
      showCancelInvitationModal: false,
    })
  }

  onCancelDelete() {
    this.setState({
      showDeleteConfirmModal: false,
      permissionToDelete: null,
    })
  }

  onClickDelete(permission) {
    this.setState({
      permissionToDelete: permission,
      showDeleteConfirmModal: true,
    })
  }

  onClickEdit(permission) {
    this.setState({
      permissionToEdit: permission,
      showEditConfirmModal: true,
    })
  }

  onCancelEdit = () => {
    this.setState({
      permissionToEdit: null,
      showEditConfirmModal: false,
    })
  }

  copyToClipboard = () => {
    const { promoterGenericInvitation } = this.props
    const promoterLink = `${window.location.origin}/team-invitations/${promoterGenericInvitation?.token}`
    navigator.clipboard.writeText(promoterLink)
  }

  filterMembersByRole = (members, role) => {
    if (role === 'all') return members
    return members.filter(member => member.roleBrand?.role === role)
  }

  render() {
    const { invitations, members, promoterGenericInvitation, user } = this.props
    const {
      loadingGenericPromoterInvitation,
      loadingInvitations,
      loadingMembers,
      showNewInvitationModal,
      showCancelInvitationModal,
      invitationToCancel,
      cancelingInvitation,
      showDeleteConfirmModal,
      permissionToDelete,
      deleting,
      showEditConfirmModal,
      permissionToEdit,
      selectedRoleFilter,
    } = this.state

    let updatedMembers = []
    if (Array.isArray(members)) {
      updatedMembers = members.map(m => {
        const roleBrand = m.relationships.permissions.data.find(
          r => r.attributes.enabled && r.attributes.scope === 'brand',
        )
        const roleTour = m.relationships.permissions.data.find(
          r => r.attributes.enabled && r.attributes.scope === 'tour',
        )

        const manufacturer = m.relationships.permissions.data.find(
          r => r.attributes.enabled && r.attributes.manufacturerId,
        )
        return {
          id: m.id,
          attributes: m.attributes,
          roleBrand: roleBrand ? { ...roleBrand.attributes, id: roleBrand.id } : null,
          roleTour: roleTour ? { ...roleTour.attributes, id: roleTour.id } : null,
          currentManufacturer: manufacturer.attributes.manufacturerId == this.props.brand.id,
        }
      })
    }
    updatedMembers = updatedMembers.filter(m => (user.tfStaff ? true : !IS_TF_MEMBER(m)))

    // Store complete member list for permission checks in getMembersTableData
    this.allMembers = updatedMembers

    // Apply role filter
    const filteredMembers = this.filterMembersByRole(updatedMembers, selectedRoleFilter)

    // Count users by role
    const roleCounts = {}
    
    // Initialize counts for all roles
    const allRoles = ['all', 'owner', 'admin', 'stats', 'limited_stats', 'curator', 'staff', 'promoter', 'support', 'limited_support']
    allRoles.forEach(role => {
      roleCounts[role] = 0
    })
    
    // Count total members
    roleCounts.all = updatedMembers.length
    
    // Count members by role
    updatedMembers.forEach(member => {
      const role = member.roleBrand?.role
      if (role && roleCounts.hasOwnProperty(role)) {
        roleCounts[role]++
      }
    })

    const deleteConfirmMsg = permissionToDelete
      ? 'Are you sure to delete ' +
        permissionToDelete.attributes.firstName +
        ' ' +
        permissionToDelete.attributes.lastName +
        "'s " +
        ROLES_MAP[permissionToDelete.roleBrand.role] +
        ' permission?'
      : ''
    const invitationCancelConfirmMsg = invitationToCancel
      ? 'Are you sure you want to cancel the ' +
        ROLES_MAP[invitationToCancel.role] +
        ' team invitation to ' +
        invitationToCancel.email +
        '?'
      : ''
    const showGenericPromoterInvitationButton =
      promoterGenericInvitation?.status === 'pending' || promoterGenericInvitation?.status === 'disabled'
    const isActivatedGenericPromoterInvitation = promoterGenericInvitation?.status === 'pending'
    const promoterLink = `${window.location.origin}/team-invitations/${promoterGenericInvitation?.token}`

    // Define role tabs with counts
    const baseRoleTabs = [
      { key: 'all', label: 'All Roles', icon: 'users', priority: 0 },
      { key: 'owner', label: 'Owner', icon: 'star', priority: 1 },
      { key: 'admin', label: 'Administrator', icon: 'user', priority: 1 },
      { key: 'stats', label: 'Stats', icon: 'bar-chart', priority: 2 },
      { key: 'limited_stats', label: 'Limited Stats', icon: 'line-chart', priority: 2 },
      { key: 'curator', label: 'Curator', icon: 'edit', priority: 2 },
      { key: 'staff', label: 'Door Staff', icon: 'key', priority: 2 },
      { key: 'promoter', label: 'Promoter', icon: 'bullhorn', priority: 2 },
      { key: 'support', label: 'Customer Support', icon: 'life-ring', priority: 2 },
      { key: 'limited_support', label: 'Limited Support', icon: 'question-circle', priority: 2 },
    ]

    // Sort tabs: All first, then Owner/Admin, then others by count descending
    const roleTabs = baseRoleTabs
      .map(tab => ({
        ...tab,
        count: roleCounts[tab.key] || 0,
        displayLabel: tab.key === 'all' 
          ? `${tab.label} (${roleCounts[tab.key]})` 
          : `${tab.label} (${roleCounts[tab.key] || 0})`
      }))
      .sort((a, b) => {
        // All Roles always first
        if (a.key === 'all') return -1
        if (b.key === 'all') return 1
        
        // Owner and Admin next (maintain their order)
        if (a.priority === 1 && b.priority === 1) {
          return a.key === 'owner' ? -1 : 1
        }
        if (a.priority === 1) return -1
        if (b.priority === 1) return 1
        
        // Rest sorted by count descending
        return b.count - a.count
      })

    // Store the dynamic role order for use in getMembersSortedRows
    this.dynamicRoleOrder = roleTabs
      .filter(tab => tab.key !== 'all')
      .map(tab => tab.key)

    return (
      <div className="brand-team">
        
        {/* Sticky invite button above tabs */}
        <div className="sticky-invite-button-container">
          <Button className="btn btn-success" onClick={this.onClickNewInvitation}>
            <i className="fa fa-fw fa-plus" /> Invite New Team Member
          </Button>
        </div>

        {/* Invite Your Promoters section */}
        <div className="invite-promoters-section">
          <h3 className="heading_style">Invite Your Promoters</h3>
          {promoterGenericInvitation?.token ? (
            <div className="row">
              <div className="col-xs-12">
                <label className="autoslugfield-label">
                  Copy Promoter Invitation Link
                  <Clipboard text={promoterLink} />
                </label>
                <div className="wrapper-promoter-link-box">
                  <div aria-hidden onClick={this.copyToClipboard} className="wrapper-promoter-link">
                    <img
                      alt="no data"
                      className="ico-show-small image-promoter-link"
                      src={asset('/resources/images/system_icons/links.svg')}
                    />
                    <div className="link-prefix-url" style={{ display: 'flex', flexDirection: 'row' }}>
                      {promoterLink}
                      <Clipboard containerStyle={{ marginLeft: 10 }} text={promoterLink} />
                    </div>
                  </div>
                  <div className="generic-buttons-box">
                    <Button
                      className="btn btn-default btn-shadow"
                      type="button"
                      disabled={!isActivatedGenericPromoterInvitation}
                      onClick={() => {
                        this.setState(prevState => ({ ...prevState, showInvitationLinkChangeModal: true }))
                      }}
                    >
                      <i className="fa fa-undo" /> Regenerate
                    </Button>
                    {showGenericPromoterInvitationButton && (
                      <Button
                        className={`btn ${
                          isActivatedGenericPromoterInvitation ? 'btn-danger' : 'btn-success'
                        } btn-shadow`}
                        type="button"
                        style={{ marginLeft: 10 }}
                        onClick={this.disableOrEnableGenericPromoterInvitation}
                      >
                        <i className="fa fa-minus-circle" aria-hidden="true" />{' '}
                        {isActivatedGenericPromoterInvitation ? 'Deactivate' : 'Enable'}{' '}
                        {loadingGenericPromoterInvitation && (
                          <i className="fa fa-circle-o-notch fa-fw fa-spin" />
                        )}
                      </Button>
                    )}
                    <Modal
                      className="event-team-new-invitation modal-trans"
                      style={modalStyle}
                      isOpen={this.state.showInvitationLinkChangeModal}
                      contentLabel="Modal"
                      onRequestClose={this.onCancelNewInvitation}
                      closeTimeoutMS={150}
                      ariaHideApp={false}
                    >
                      <div className="modal-dialog">
                        <div className="modal-content">
                          <div className="modal-header">Confirm</div>
                          <div className="modal-body">Regenerating the link will invalidate the old link.</div>
                          <div className="modal-footer">
                            <div className="btn-toolbar btn-toolbar-right">
                              <Button
                                className="btn btn-success btn-shadow"
                                type="button"
                                onClick={() => {
                                  this.regenerateGenericPromoterInvitation()
                                  this.setState(prevState => ({
                                    ...prevState,
                                    showInvitationLinkChangeModal: false,
                                  }))
                                }}
                              >
                                Regenerate
                              </Button>
                              <Button
                                className="btn btn-default btn-shadow"
                                type="button"
                                onClick={() => {
                                  this.setState(prevState => ({
                                    ...prevState,
                                    showInvitationLinkChangeModal: false,
                                  }))
                                }}
                              >
                                Go back
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Modal>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <i className="fa fa-circle-o-notch fa-fw fa-spin" />
          )}
        </div>

        <h3 className="heading_style">Team Members</h3>

        {/* Role filter tabs */}
        <div className="role-filter-tabs">
          {roleTabs.map(tab => (
            <div
              key={tab.key}
              className={`role-tab ${selectedRoleFilter === tab.key ? 'active' : ''}`}
              onClick={() => this.setState({ selectedRoleFilter: tab.key })}
            >
              <i className={`fa fa-${tab.icon}`} />
              <span>{tab.displayLabel}</span>
            </div>
          ))}
        </div>

        <div className="brand-team-members">
          {loadingMembers && (
            <LoadingBar key="loadingbar" title={"Hold tight! We're getting your brand's team members..."} />
          )}
          {!loadingMembers && (
            <JSONDatatable
              type={TYPE_FROM_ARRAY}
              data={filteredMembers}
              sort={{ index: 0, asc: true }}
              getFilteredRows={this.getMembersFilteredRows}
              getSortedRows={this.getMembersSortedRows}
              getTableData={this.getMembersTableData}
              autoRefresh={20 * 1000}
              loadingBarTitle={"Hold tight! We're getting your brand's team members..."}
            >
              <div ref={SEARCHBAR} hasSearch labelTotalCount="Number of Matching Members" />
              <div ref={DATATABLE} />
            </JSONDatatable>
          )}
        </div>
        <h3 className="heading_style">Team Invitations</h3>
        <div className="brand-team-invitations">
          {loadingInvitations && (
            <LoadingBar
              key="loadingbar"
              title={"Hold tight! We're getting your brand's team invitations..."}
            />
          )}
          {!loadingInvitations && (
            <JSONDatatable
              type={TYPE_FROM_ARRAY}
              data={invitations}
              sort={{ index: 0, asc: true }}
              getFilteredRows={this.getInvitationsFilteredRows}
              getSortedRows={this.getInvitationsSortedRows}
              getTableData={this.getInvitationsTableData}
              autoRefresh={20 * 1000}
              loadingBarTitle={"Hold tight! We're getting your brand's team invitations..."}
            >
              <div ref={SEARCHBAR} hasSearch labelTotalCount="Number of Matching Invitations" />
              <div ref={DATATABLE} />
            </JSONDatatable>
          )}
        </div>
        <Modal
          className="event-team-new-invitation modal-trans"
          style={modalStyle}
          isOpen={showNewInvitationModal}
          contentLabel="Modal"
          onRequestClose={this.onCancelNewInvitation}
          closeTimeoutMS={150}
          ariaHideApp={false}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">New Team Invitation</div>
              <div className="modal-body">
                <BrandTeamInvitationForm
                  onSubmit={this.handleNewInvitationSubmit}
                  onCancel={this.onCancelNewInvitation}
                  submitLabel={'Invite'}
                  initialValues={INVITATION_INITIAL_VALUES}
                  isNew={true}
                />
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          className="event-team-new-invitation modal-trans"
          style={modalStyle}
          isOpen={showEditConfirmModal}
          contentLabel="Modal"
          onRequestClose={this.onCancelEdit}
          closeTimeoutMS={150}
          ariaHideApp={false}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">Edit Team Invitation</div>
              <div className="modal-body">
                <BrandEditTeamInvitationForm
                  onSubmit={this.handleEditInvitationSubmit}
                  onCancel={this.onCancelEdit}
                  submitLabel={'Edit'}
                  initialValues={{
                    attributes: {
                      role: permissionToEdit?.roleBrand?.role,
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          className="event-team-delete-confirm modal-trans"
          style={modalStyle}
          isOpen={showDeleteConfirmModal}
          contentLabel="Modal"
          onRequestClose={this.onCancelDelete}
          closeTimeoutMS={150}
          ariaHideApp={false}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">Permission Delete</div>
              <div className="modal-body">{deleteConfirmMsg}</div>
              <div className="modal-footer">
                <div className="btn-toolbar btn-toolbar-right">
                  <Button
                    className="btn btn-success btn-shadow"
                    type="button"
                    onClick={this.deletePermission}
                    disabled={deleting}
                  >
                    Ok
                  </Button>
                  <Button
                    className="btn btn-default btn-shadow"
                    type="button"
                    onClick={this.onCancelDelete}
                    disabled={deleting}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          className="brand-team-cancel-invitation-confirm modal-trans"
          style={modalStyle}
          isOpen={showCancelInvitationModal}
          contentLabel="Modal"
          onRequestClose={this.onCancelInvitationCancel}
          closeTimeoutMS={150}
          ariaHideApp={false}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">Invitation Cancel</div>
              <div className="modal-body">{invitationCancelConfirmMsg}</div>
              <div className="modal-footer">
                <div className="btn-toolbar btn-toolbar-right">
                  <Button
                    className="btn btn-success btn-shadow"
                    type="button"
                    onClick={this.cancelInvitation}
                    disabled={cancelingInvitation}
                  >
                    Ok
                  </Button>
                  <Button
                    className="btn btn-default btn-shadow"
                    type="button"
                    onClick={this.onCancelInvitationCancel}
                    disabled={cancelingInvitation}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}
